import alertAction from '@/js/_components/head-alert';
import formsInputSelect from '@/js/_components/forms/input-select';
import formsInputImage from '@/js/_components/forms/input-image.js';
import formsDatePicker from '@/js/_components/forms/date-picker';
import jobSearchFilter from '@/js/_components/parts/job-search-filter';
import magazineSearchFilter from '@/js/_components/parts/magazine-search-filter';
import news from '@/js/_components/parts/news';
import favorite from '@/js/_components/parts/favorite';
import colorPicker from '@/js/_components/parts/color-picker';
import profileAddGuide from '@/js/_components/parts/profile-add-guide';
import headerTabs from '@/js/_components/parts/header-tabs';
import { initChatUnreadChecker } from '@/js/_components/chat/unread-checker';
import { socket as socketConfig } from '@/jsx/config/index.js';
import smoothScroll from 'smooth-scroll';
import { isSp } from '@/js/_common';

const menuOpenAction = (media) => {
    const mq = isSp() ? 'sp' : 'pc';
    if (media !== mq) return;
    const menuObj = document.querySelector('.c-parts-global-menu');
    document.querySelector('.c-parts-global-menu').dataset.open = 'true';
}

const setGlobalMenuAction = () => {
    if (document.querySelector('.c-layouts-header-actions__icon')) {
        // sp用のメニュー開閉
        document.querySelector('.c-layouts-header-actions__icon').addEventListener('click', () => {
            menuOpenAction('sp');
        });

        // pc用のメニュー開閉
        document.querySelector('.c-layouts-header-actions__icon').addEventListener('mouseover', () => {
            menuOpenAction('pc');
        });

        document.querySelector('.c-parts-global-menu__close').addEventListener('click', () => {
            document.querySelector('.c-parts-global-menu').dataset.open = 'false';
        });
    }
}

const main = () => {
    alertAction();
    formsInputSelect();
    formsInputImage();
    formsDatePicker();
    jobSearchFilter();
    magazineSearchFilter();
    favorite();
    news();
    setGlobalMenuAction();
    headerTabs();
    colorPicker();
    profileAddGuide();


    // ログインユーザー && チャット画面でない場合、チャット未読通知をSocket経由で受信
    if (document.querySelector('body[data-login="logged-in"]') && !document.querySelector('#chat-root')) {
        initChatUnreadChecker(socketConfig.baseUrl, '/api/user/unread-status');
    }

    /*
    const scroll = new smoothScroll('a[href*="#"]', {
        speed: 400,
        speedAsDuration: true,
        easing: 'easeInOutCubic',
    });
    */
}
export default main;
